import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiChevronLeft, FiFileText, FiClock } from 'react-icons/fi';
import { ROUTES } from '../../app/routes';
import PolicySummaryUpload from './PolicySummaryUpload';
import PolicySummaryHistory from './PolicySummaryHistory';
import '../commissionscan/CommissionScan.css';
import './PolicyComparison.css';
const PolicySummaryPage: React.FC = () => {
    const navigate = useNavigate();
    const [view, setView] = useState<'new' | 'history'>('new');
    return (<div className="cs-page">
      
      <div className="cs-sidebar">
        <button className="cs-back-link" onClick={() => navigate(ROUTES.MARKETPLACE)}>
          <FiChevronLeft size={14}/>
          Back to Marketplace
        </button>
        <nav className="cs-nav">
          <button className={`cs-nav__item${view === 'new' ? ' cs-nav__item--active' : ''}`} onClick={() => setView('new')}>
            <FiFileText size={15}/>
            New Summary
          </button>
          <button className={`cs-nav__item${view === 'history' ? ' cs-nav__item--active' : ''}`} onClick={() => setView('history')}>
            <FiClock size={15}/>
            History
          </button>
        </nav>
      </div>

      
      <div className={`cs-main${view === 'history' ? ' cs-main--history' : ''}`}>
        {view === 'history' ? (<PolicySummaryHistory />) : (<PolicySummaryUpload onGoToHistory={() => setView('history')}/>)}
      </div>
    </div>);
};
export default PolicySummaryPage;
